
import { Component, Vue } from "vue-property-decorator";

@Component
export default class SolicitaAtencion extends Vue {

    private nombreWeb: any = "";

    private mounted() {
    }

    private routerGo(name: string) {
        if (name && name != "") {
            if (this.$router.currentRoute.name == name) {
                this.$router.go(0);
            } else {
                this.$router.push({ name: name }).catch(err => {
                    console.log(err);
                });
            }
        }
    }
    private toLink(item: any, blank: any) {
        if (item && item != "") {
            if (blank == 1) {
                window.open(item, "_blank");
            } else {
                window.open(item, "_self");
            }
        } else {
            return;
        }
    }
}
